import { createAction, props } from '@ngrx/store';

/** Create action */
export const reset = createAction('[News Feed] Reset');

export const updateCurrentUserImage = createAction(
  '[News Feed] Update Current User Image',
  props<{ userId: string; url: string }>(),
);
